import { render, staticRenderFns } from "./moment.vue?vue&type=template&id=5bd27fd5&scoped=true"
import script from "./moment.vue?vue&type=script&lang=js"
export * from "./moment.vue?vue&type=script&lang=js"
import style0 from "./moment.vue?vue&type=style&index=0&id=5bd27fd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd27fd5",
  null
  
)

export default component.exports